import { Box, Typography } from '@mui/material';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import {
  AppFormikTextArea,
  AppPrimaryButtonOutlined,
} from 'shared/components/AppComponents';
import { Formik } from 'formik';

const RiskRegisterComments: React.FC<any> = () => (
  <Box className="app-plain-card mt-4">
    <Box className="title">
      <Box sx={{ display: 'flex', gap: '0.5rem', justifyItems: 'center' }}>
        <Box sx={{ position: 'relative', top: '0.25rem' }}>
          <ChatBubbleOutlineIcon />
        </Box>
        <Typography variant="h4"> Comments (0)</Typography>
      </Box>
      <Typography variant="body1" mt={3}>
        Discussion and notes about new risk
      </Typography>

      <Formik
        initialValues={{ comments: '' }}
        validationSchema=""
        validateOnMount
        enableReinitialize
        onSubmit={(formValues, formik) => console.log(formValues, formik)}
      >
        {({ values }) => (
          <Box
            sx={{
              borderRadius: '5px',
              border: '1px solid #c4c4c4',
              padding: '20px 35px',
            }}
            mt={5}
          >
            <AppFormikTextArea
              name="comments"
              placeholder="write a comment..."
              label=""
              outerLabel
              rows={3}
            />
            <Box sx={{ textAlign: 'right' }} mt={5}>
              <AppPrimaryButtonOutlined
                disabled={!values?.comments}
                title="Comment"
                onClick={() => {}}
              />
            </Box>
          </Box>
        )}
      </Formik>
    </Box>
  </Box>
);

export default RiskRegisterComments;
